const messages = {
  profile_updated: "Profile updated successfully!"
}

const proxyHandler = {
  get: (obj, prop) => {
    return prop in obj ? obj[prop] : obj.default
  }
}

export const successMessages = new Proxy(messages, proxyHandler)
